import React, { Component } from "react";
import { ListGroup } from "react-bootstrap";

class ReviewTasks extends Component<any, any> {
  render() {
    return (
      <div>
        <h2>Review Tasks</h2>
      </div>
    );
  }
}

export default ReviewTasks;
